import FormikInputField from "components/common/Fields/FormikInputField";
import FormikSelectField from "components/common/Fields/FormikSelectField";
import ErrorBoundary from "components/ErrorBoundary";
import { Field } from "formik";
import useAxios from "hooks/useAxios";
import AccumulatorTab from "pages/Configuration/AccumulatorTab";
import Location from "pages/Configuration/Location";
import OrderingTab from "pages/Configuration/OrderingTab";
import PatientType from "pages/Configuration/PatientType";
import PayorTab from "pages/Configuration/PayorTab";
import Rule from "pages/Configuration/Rule";
import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Select from "react-select";
import {
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { onExport } from "utils/helper";
import { LimitedChipsContainer, Option } from "components/Options";
import useContextService from "hooks/useContextService";
import { cloneDeep } from "lodash";
import Loader from "components/Loader";
import ReactSelect from "react-select";
import General from "pages/Configuration/GeneralTab";
let RuleHardCodedata = [];
let StatusHardCodedata = [];
const CEConfigurationsTabs = (props) => {
  const initialStates = {
    currentPage: 1,
    pageSize: 10,
    order: 'desc',
    orderBy: 'modifiedDate',
    filters: [],
  }
  const {
    states: { configAccumulatorType },
    setStates,
  } = useContextService();
  const { search } = configAccumulatorType;
  const { rowData, orgId ,CEDid,setLoading,
  loading } = props;
  const API = useAxios();
  const [key, setkey] = useState("general");
  const [reset, setReset] = useState(false);
  const [data, setData] = useState([]);
  const [AccumulatorTable, SetAccumulatorTable] = useState([]);
  const [AccumulatorData, SetAccumulatorData] = useState([]);
  const [SelectedAccumulator, SetSelectedAccumulator] = useState(null);
  const [selectedRule, setSelectedRule] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [accmulatorRecords, setAccmulatorReocords] = useState("");
  const [desablestatus, setdesablestatus] = useState(false);

  // const [loading, setLoading] = useState(false);

  const onKeyChange = (k) => {
    setkey(k);
    setReset(!reset);
  };
  // const handleExport = async () => {
  //   const { access_token } =
  //     JSON.parse(localStorage.getItem("pharmaforce")) || {};
  //   const action = `${process.env.REACT_APP_ENDPOINT}/CPConfig/configuration/ConfigurationExportAll?access_token=${access_token}`;
  //   onExport(action, search);
  // };


// const handleExport = async() =>{

// const filterObj = cloneDeep(search);

// if (columnFilters && columnFilters.length > 0) {
//   filterObj.filters = [...filterObj.filters, ...columnFilters];
// }

// const { access_token } =
// JSON.parse(localStorage.getItem('pharmaforce')) || {};

// var additionalCriteria = {};
// additionalCriteria.IsSelectedColumn = false;
// additionalCriteria.OrgId = orgId.organizationID;

// var payload = {};
// payload.tenantID = orgId.tenantID
// payload.gridCode = "Configuration";
// payload.fileTypeCode = "csv";
// payload.criteria = JSON.stringify(filterObj);
// payload.additionalCriteria = JSON.stringify(additionalCriteria);
// const { data } = await API.post(`export/queue`, payload, {
//   hasExport: true,
// });

// }



  useEffect(() => {
    handelAccumulator(search);
  }, [SelectedAccumulator]);

  const handelAccumulator = async (filterObj) => {


    if (filterObj != undefined) {
      initialStates.filters = filterObj.filters;
      initialStates.order = filterObj.order
        ? filterObj.order
        : initialStates.order;
      initialStates.orderBy = filterObj.orderBy
        ? filterObj.orderBy
        : initialStates.orderBy;
      initialStates.currentPage = filterObj.currentPage
        ? filterObj.currentPage
        : initialStates.currentPage;
    }
    if (filterObj == undefined) {
      filterObj = initialStates
    }
    setLoading(true);
    try {
      const { data } = await API.post(
        `SBConfig/coveredentity/accumulationlist/${CEDid}`,
        filterObj,
        {
          hasDefaultURL: true,
        }
      );
      SetAccumulatorTable(data.items);
      setAccmulatorReocords(data.totalRecords);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const handelAccmulatorSelect = async () => {

    // SetAccumulatorData([])
    setLoading(true);
    try {
      const payload = [];
      setLoading(true);
      payload.AccumulatorEntityList = rowData.coveredEntityID;
      let AccumulatorEntityList = [payload.AccumulatorEntityList];
      setLoading(true);
      const data = await API.get(

        `SBConfig/coveredentity/acclist/${AccumulatorEntityList}`,
        {
          hasDefaultURL: true,
        }
      );
      setLoading(true);
      const formattedOptions = data.data.map((item) => ({
        value: item.accumulatorID,
        label: item.ceName,
      }));

      SetAccumulatorData(formattedOptions);
      if (formattedOptions.length === 1) {
        SetSelectedAccumulator(formattedOptions[0]);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    handelAccmulatorSelect();

  }, []);


  const handelAccumulatorChange = (selected) => {
    SetSelectedAccumulator(selected);
  };
  const fetchRule = async () => {
    debugger;
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/ruledropdown`, { hasDefaultURL: true });
      console.log(data, "Account Type Data")
      for (var x in data) {
        RuleHardCodedata.push({ "value": data[x].id, "label": data[x].description })
      }
      console.log(RuleHardCodedata, "RuleHardCodedata Type Data")
    }

    catch (err) {

    }
  }
  useEffect(() => {
    RuleHardCodedata = [];
    StatusHardCodedata = [];
    fetchRule();
    fetchStatus();
  }, [])
  const fetchStatus = async () => {
    try {
      const { data } = await API.get(`SBConfig/TypeStatus/ruleStatusdropdown`, { hasDefaultURL: true });
      console.log(data, "Account Type Data")
      for (var x in data) {
        StatusHardCodedata.push({ "value": data[x].id, "label": data[x].description })
      }
      console.log(StatusHardCodedata, "StatusHardCodedata Type Data")
    }

    catch (err) {

    }
  }


  const handelRuleChange = async (selectedOption) => {
    debugger;
    setSelectedRule(selectedOption);
    if(selectedOption.label == "ProviderNPI")
    {
      setSelectedStatus(StatusHardCodedata[0])
      setdesablestatus(true);
    }
    else{
      setSelectedStatus(StatusHardCodedata[1])
      setdesablestatus(true);
    }
  };

  const handelStatusChange = async (selected) => {
    
        setSelectedStatus(selected);
  };

  // // useEffect(() => {
  // //   handelAccmulatorSelect();
  // // }, [SelectedAccumulator]);


  const handleSearchColumnFilters = async (columnFilters) => {
    debugger;
    const filterObj = cloneDeep(search);
    if (columnFilters && columnFilters.length > 0) {
      filterObj.filters = [...filterObj.filters, ...columnFilters];
    }
    await handelAccumulator(filterObj);
  };

  const handlePageChange = (filter, haveColFilter) => {
    const filterObj = cloneDeep(initialStates);

    if (haveColFilter) {
      //   filterObj.filters = [...filterObj.filters, ...filter.filters];
      filterObj.currentPage = filter.currentPage;
      filterObj.pageSize = filter.pageSize;
      filterObj.orderBy = filter.orderBy;
      filterObj.order = filter.order;

      handelAccumulator(filterObj);
    } else {
      filterObj.orderBy = filter.orderBy;
      filterObj.order = filter.order;

      handelAccumulator(filterObj);
    }
  };
  const handleResetRule = () => {
    debugger
    setSelectedRule("");
    setSelectedStatus("");
    setdesablestatus(false);
  }

  const handledesablestatus = () => {
     debugger
    // if (desablestatus) {
    //   setdesablestatus(false);
    // } else {
    //   setdesablestatus(true);
    // }
    setdesablestatus(true);
  }

  return (
    <div>
      {/* <Container>
        <Card>
          <CardBody>
            <ErrorBoundary>
              <Row>
                <h4 className="f-15 text-primary font-weight-700">
                  Covered Entity Configuration{" "}
                </h4>
                {key !== "accumulatorTab" ? (
                  <Col md="6">
                    <p className="m-0 f-14 mt-3">Covered Entity/(OPAID) :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">
                      {rowData.coveredEntityName}
                    </p>
                  </Col>
                ) : (
                  <Col md="6">
                    <p className="m-0 f-14 mt-3">Covered Entity :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">
                      {rowData?.coveredEntityName}
                    </p>
                  </Col>
                )}
                <Col md="6">
                  <p className="m-0 f-14 mt-3">Covered Entity Type :</p>
                  <p className="m-0 f-14 font-weight-500 mt-1">
                    {rowData.coveredEntityTypeName}
                  </p>
                </Col>
                {key === "accumulatorTab" ? (
                  <Col md="6">
                    <p className="m-0 f-14 mt-3">OPAID :</p>
                    <p className="m-0 f-14 font-weight-500 mt-1">
                      {rowData.opaCode}
                    </p>
                  </Col>
                ) : (
                  <>
                    <Col md="4">
                      <p className="m-0 f-14 mt-3">Accumulator</p>
                      <Select
                        name="accumulator"
                        id="accumulator"
                        options={AccumulatorData}
                        closeMenuOnSelect={true}
                        hideSelectedOptions={false}
                        value={SelectedAccumulator}
                        onChange={(e) => handelAccumulatorChange(e)}
                        isSearchable={true}
                        maxMenuHeight={220}
                        styles={{
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 99,
                          }),
                        }}
                      />
                    </Col>
                    <Col md="2">{""}</Col>
                  </>
                )}

                {key === "rule" ? (
                  <>
                    <Col md="4" className="m-0 f-14 mt-2">
                      {" "}
                      <p className="m-0 f-14 mt-1">Rule</p>
                      <ReactSelect
                        id="rule"
                        name="rule"
                        value={selectedRule}
                        options={RuleHardCodedata}
                        // component={FormikSelectField}
                        placeholder="Select Rule"
                        onChange={(e) => handelRuleChange(e)}
                        keys={{
                          value: "value",
                          label: "label",
                        }}
                      />
                    </Col>

                    <Col md="4" className="m-0 f-14 mt-3">
                      {" "}
                      <p className="m-0 f-14 ">Status</p>
                      <ReactSelect
                        id="status"
                        name="status"
                        value={selectedStatus}
                        options={StatusHardCodedata}
                        isDisabled={desablestatus}
                        placeholder="Select Status"
                        component={FormikSelectField}
                        onChange={(e) => handelStatusChange(e)}
                        keys={{
                          value: "value",
                          label: "label",
                        }}
                      />
                    </Col>
                  </>
                ) : (
                  ""
                )}
              </Row>
            </ErrorBoundary>
          </CardBody>
        </Card>
      </Container> */}
      <Container fluid className="my-3 bin_info p-0">
        <Card className='border-0 shadow-top'>
          <CardBody>
          <Tabs
          id="controlled-tab-example"
          activeKey={key}
          // onSelect={(k) => setkey(k)}
          onSelect={(k) => onKeyChange(k)}
          className="mb-3"
        >
          <Tab eventKey="general" title="General">
            {/* {loading && <Loader opacity={0.02} color="black" />}
            <AccumulatorTab
              AccumulatorTable={AccumulatorTable}
              rowData={rowData}
              accmulatorRecords={accmulatorRecords}
              handelAccumulator={handelAccumulator}
              handelSort={handlePageChange}
              filter={search}
              onSearchColumnFilter={handleSearchColumnFilters}
            /> */}
            <General               
            orgId={orgId}
              keyname={key}
              rowData={rowData}
              SelectedAccumulator={rowData.accumulatorID}
              setLoading={setLoading}
                loading={loading}
              />
          </Tab>
          <Tab eventKey="ordering" title="Wholesaler">
            {/* {loading && <Loader opacity={0.02} color="black" />} */}
            <OrderingTab
            keyname={key}
            orgId={orgId}
              rowData={rowData}
              SelectedAccumulatorOrder={rowData.accumulatorID}
              setLoading={setLoading}
                loading={loading}
            />
          </Tab>
          {/* {loading && <Loader opacity={0.02} color="black" />} */}

          <Tab eventKey="locationTab" title="Location">
            <Location
              orgId={orgId}
              keyname={key}
              rowData={rowData}
              SelectedAccumulator={rowData.accumulatorID}
              setLoading={setLoading}
                loading={loading}
            />
          </Tab>
          <Tab eventKey="rule" title="Charge Rules">
            <Rule
            setSelectedRule={setSelectedRule}
            keyname={key}
              orgId={orgId}
              rowData={rowData}
              selectedRule={selectedRule}
              selectedStatus={selectedStatus}
              SelectedAccumulatorRule={rowData.accumulatorID}
              handleResetRule={handleResetRule}
              //statusdesable={statusdesable}
              handledesablestatus={handledesablestatus}
              StatusHardCodedata={StatusHardCodedata}
              RuleHardCodedata={RuleHardCodedata}
              desablestatus={desablestatus}
              handelRuleChange={handelRuleChange}
              setLoading={setLoading}
                loading={loading}
                // onExport={handleExport}
                handlestu={handelStatusChange}
                onSearchColumnFilter={handleSearchColumnFilters}
            />
          </Tab>
        </Tabs>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default CEConfigurationsTabs;
